<div class="backdrop" (click)="onClose()"></div>

<div class="container">
  <img routerLink="/loa/participacao" src="assets/images/popup_loa.svg" alt="Formulário de participação do Plano Plurianual">
</div>
